module.exports = __webpack_public_path__ + "static/media/intro-bg-mob-right.de28bb39.svg";